export default "__VITE_ASSET__DrIhBMMH__"